<i *ngIf="checked !== false" class="material-icons">{{ checked === true ? 'check' : 'remove' }}</i>
